export const formatNumber = (value?: number, symbol: string = ""): string => {
  if (value === undefined || isNaN(value)) return `0${symbol}`;
  return `${value.toFixed(2)}${symbol}`;
};
